import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	token: "",
	username: "",
	idnDbDomain: "",
	codSocieta: "",
	codSede: "",
	menu: "",
	ipAddress: "",
	hostname: "",
	idPersona: "",
	dashboard: "",
	flCambioPassword: "",
	sediUtente: [],
	objMod: [],
	ruoliUtente: [],
	linguaIso: "",
	backendVersion: "",
	databasePatch: "",
	databaseVersion: "",
	oldBackendVersion: "",
	// OneTrueId
	oneTrueIdToken: "",
	oneTrueIdUsername: "",
	oneTrueIdRefreshToken: "",
	oneTrueIdRoles: [],
	oneTrueIdIsMaker: false,
};

export const authSlice = createSlice({
	name: "auth",
	initialState,
	reducers: {
		setUserPreferences: (state, action) => {
			state.token = action.payload.token;
			localStorage.setItem("jswsToken", action.payload.token);
			state.dashboard = action.payload.userPreferences.dashboard;
			state.username = action.payload.userPreferences.username;
			state.idnDbDomain = action.payload.userPreferences.idnDbDomain;
			state.codSocieta = action.payload.userPreferences.codSocieta;
			state.codSede = action.payload.userPreferences.codSede;
			state.menu = action.payload.userPreferences.menu;
			state.ipAddress = action.payload.userPreferences.ipAddress;
			state.hostname = action.payload.userPreferences.hostname;
			state.idPersona = action.payload.userPreferences.idPersona;
			state.flCambioPassword = action.payload.userPreferences.flCambioPassword;
			state.sediUtente = action.payload.userPreferences.sediUtente;
			state.objMod = action.payload.userPreferences.objMod;
			state.ruoliUtente = action.payload.userPreferences.ruoliUtente;
			state.linguaIso = action.payload.userPreferences.linguaIso;
			state.backendVersion = action.payload.userPreferences.backendVersion;
			state.databasePatch = action.payload.userPreferences.databasePatch;
			state.databaseVersion = action.payload.userPreferences.databaseVersion;
			state.oldBackendVersion = action.payload.userPreferences.oldBackendVersion;
			// OneTrueId
			if (action.payload.oneTrueIdToken) {
				localStorage.setItem("oneTrueIdToken", action.payload.oneTrueIdToken);
				localStorage.setItem("oneTrueIdUsername", action.payload.oneTrueIdUsername);
				localStorage.setItem("oneTrueIdRefreshToken", action.payload.oneTrueIdRefreshToken);
				localStorage.setItem("oneTrueIdRoles", JSON.stringify(action.payload.oneTrueIdRoles));
				state.oneTrueIdToken = action.payload.oneTrueIdToken;
				state.oneTrueIdUsername = action.payload.oneTrueIdUsername;
				state.oneTrueIdRefreshToken = action.payload.oneTrueIdRefreshToken;
				state.oneTrueIdRoles = action.payload.oneTrueIdRoles;
				state.oneTrueIdIsMaker = action.payload.oneTrueIdIsMaker;
			}
		},
		unsetUserPreferences: (state) => {
			state.token = "";
			localStorage.removeItem("jswsToken");
			state.dashboard = "";
			state.username = "";
			state.idnDbDomain = "";
			state.codSocieta = "";
			state.codSede = "";
			state.menu = "";
			state.ipAddress = "";
			state.hostname = "";
			state.idPersona = "";
			state.flCambioPassword = "";
			state.sediUtente = [];
			state.objMod = [];
			state.ruoliUtente = [];
			state.linguaIso = "";
			state.backendVersion = "";
			state.databasePatch = "";
			state.databaseVersion = "";
			state.oldBackendVersion = "";
			// OneTrueId
			localStorage.removeItem("oneTrueIdToken");
			localStorage.removeItem("oneTrueIdUsername");
			localStorage.removeItem("oneTrueIdRefreshToken");
			localStorage.removeItem("oneTrueIdRoles");
			state.oneTrueIdToken = "";
			state.oneTrueIdUsername = "";
			state.oneTrueIdRefreshToken = "";
			state.oneTrueIdRoles = [];
			state.oneTrueIdIsMaker = false;
		},
		passwordCambiata: (state) => {
			state.flCambioPassword = "N";
		},
	},
});

export const { setUserPreferences, unsetUserPreferences, passwordCambiata } = authSlice.actions;

export default authSlice.reducer;
